export const COURSES_TAGS_ADMIN_ONLY_MESSAGE = 'Forbidden: admin access required';
export const COURSES_DELETE_BLOCKED_MESSAGE =
	"Reassign or delete this course's modules and challenges first.";
export const COURSES_QUIZ_PASS_PERCENTAGE = 70;
export const COURSES_EVENT_DEF_IN_USE_MESSAGE =
	'This event already has recorded data. Deactivate it instead of deleting.';
export const COURSE_LOCKED_MESSAGE = 'This course is locked.';
export const COURSES_MODULE_LOCKED_MESSAGE = 'This module is locked.';

export const COURSES_DISCUSSION_CLOSED_MESSAGE = 'This discussion is closed';
